export const userColumns = [
 
  {
    field: "branchName",
    headerName: "Branch Name",
    width: 130,
  },
  {
    field: "branchCode",
    headerName: "Branch Code",
    width: 120,
  },
  {
    field: "contactNumber",
    headerName: "Contact Number",
    width: 230,
  },

 
  {
    field: "contactPerson",
    headerName: "Contact Person",
    width: 100,
   
  },
  {
    field: "mobileNumber",
    headerName: "Mobile Number",
    width: 150,
  },
  {
    field: "emailID",
    headerName: "Email ID",
    width: 100,
  },

  {
    field: "branchAddress",
    headerName: "Address",
    width: 380,
  },
];
